import { Refine } from "@refinedev/core";
import routerProvider from "@refinedev/react-router";
import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import { NotificationStack } from "./components/ui";
import { AppLayout } from "./layout/app-layout";
import { BotsPage, BotDetailPage, CreateBotPage } from "./pages/bots";
import { BrokersPage, DataQualityPage, MarketDataPage } from "./pages/infrastructure";
import { AlertsPage, AuditPage, HealthPage } from "./pages/operations";
import { OverviewPage } from "./pages/overview";
import { PortfolioPage, RiskPage, SleevesPage } from "./pages/portfolio";
import { BacktestDetailPage, BacktestRunnerPage, BacktestsPage, CompareRunsPage, StrategiesPage } from "./pages/research";
import { SettingsPage } from "./pages/settings";
import { LoginPage } from "./pages/login";
import { LiveMonitorPage, OrdersPage, PositionsPage } from "./pages/trading";
import { AuthSessionProvider, ProtectedRoute } from "./providers/auth-session";
import { dataProvider } from "./providers/data-provider";
import { liveProvider } from "./providers/live-provider";
import { notificationProvider } from "./providers/notification-provider";

const resources = [
  { name: "bots", list: "/bots", create: "/bots/create", show: "/bots/:id", edit: "/bots/:id/edit", meta: { label: "Bots" } },
  { name: "strategies", list: "/research/strategies", meta: { label: "Strategies" } },
  { name: "orders", list: "/trading/orders", meta: { label: "Orders" } },
  { name: "positions", list: "/trading/positions", meta: { label: "Positions" } },
  { name: "backtests", list: "/research/backtests", create: "/research/backtests/create", show: "/research/backtests/:id", meta: { label: "Backtests" } },
  { name: "brokers", list: "/infrastructure/brokers", meta: { label: "Brokers" } },
  { name: "portfolios", list: "/portfolio", meta: { label: "Portfolio" } },
  { name: "dataQuality", list: "/infrastructure/data-quality", meta: { label: "Data Quality" } },
  { name: "auditLogs", list: "/operations/audit", meta: { label: "Audit Log" } },
  { name: "alerts", list: "/operations/alerts", meta: { label: "Alerts" } },
];

export default function App() {
  return (
    <BrowserRouter>
      <AuthSessionProvider>
        <Refine
          routerProvider={routerProvider}
          dataProvider={dataProvider}
          liveProvider={liveProvider}
          notificationProvider={notificationProvider}
          resources={resources}
          options={{ liveMode: "auto", mutationMode: "pessimistic", syncWithLocation: true, warnWhenUnsavedChanges: true }}
        >
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<AppLayout />}>
                <Route index element={<Navigate to="/overview" replace />} />
                <Route path="/overview" element={<OverviewPage />} />
                <Route path="/bots" element={<BotsPage />} />
                <Route path="/bots/create" element={<CreateBotPage />} />
                <Route path="/bots/:id" element={<BotDetailPage />} />
                <Route path="/bots/:id/edit" element={<BotDetailPage />} />
                <Route path="/trading/live" element={<LiveMonitorPage />} />
                <Route path="/trading/orders" element={<OrdersPage />} />
                <Route path="/trading/positions" element={<PositionsPage />} />
                <Route path="/research/strategies" element={<StrategiesPage />} />
                <Route path="/research/backtests" element={<BacktestsPage />} />
                <Route path="/research/backtests/create" element={<BacktestRunnerPage />} />
                <Route path="/research/backtests/:id" element={<BacktestDetailPage />} />
                <Route path="/research/compare" element={<CompareRunsPage />} />
                <Route path="/portfolio" element={<PortfolioPage />} />
                <Route path="/portfolio/sleeves" element={<SleevesPage />} />
                <Route path="/portfolio/risk" element={<RiskPage />} />
                <Route path="/infrastructure/brokers" element={<BrokersPage />} />
                <Route path="/infrastructure/market-data" element={<MarketDataPage />} />
                <Route path="/infrastructure/data-quality" element={<DataQualityPage />} />
                <Route path="/operations/audit" element={<AuditPage />} />
                <Route path="/operations/alerts" element={<AlertsPage />} />
                <Route path="/operations/health" element={<HealthPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="*" element={<Navigate to="/overview" replace />} />
              </Route>
            </Route>
          </Routes>
          <NotificationStack />
        </Refine>
      </AuthSessionProvider>
    </BrowserRouter>
  );
}
